import React from 'react';
import GridSection from '../../../../components/grid-section';
import InfiniteScroll from '../../../../components/infinite-scroll';
import Loading from '@ifit/mp-loading';
import { getSortBy } from '../../../../helpers/sorting';
import './index.scss';
import classnames from 'classnames';
import {
  searchResultsText,
  searchResultsWithCountText,
  searchResultsWithFiltersCount,
  noSearchResultsText,
} from '../../../../i18n/translations';
import { getSearchState } from '../../state/search-state';

interface IProps {
  results: any;
  loadMore: () => void;
  isLoading: boolean;
  usingFilters: boolean;
  filterCount: number;
  searchText: string;
  hasMoreItems: boolean;
  totalItems: number;
  selectedSortingOption;
  sortOptions: string[];
}

const SearchResults = ({
  results,
  isLoading,
  loadMore,
  usingFilters,
  filterCount,
  searchText,
  hasMoreItems,
  totalItems,
  selectedSortingOption,
  sortOptions,
}: IProps): JSX.Element => {
  function onSortingChanged(sortLabel): void {
    getSearchState().changeSort(getSortBy(sortLabel));
  }

  const { data = [], page } = results || {};
  const loadingSpinner = isLoading && (
    <Loading zIndex={11} data-testid="loading-spinner" />
  );
  const filterCountTitle =
    filterCount > 0 ? searchResultsWithFiltersCount(filterCount) : '';

  const title = usingFilters
    ? searchResultsWithCountText(totalItems, searchText)
    : searchResultsText();

  const searchTitleMaxCharacters = 46;

  const showNoResults = !data.length && !isLoading;
  const noResults = showNoResults && (
    <div className="no-results">{noSearchResultsText()}</div>
  );

  return (
    <div
      className={classnames(
        'results-view',
        showNoResults ? 'no-results-view' : '',
      )}
    >
      {loadingSpinner}
      <InfiniteScroll
        reset={page === 1}
        loadMore={loadMore}
        hasMoreItems={hasMoreItems}
        libraryCards={data}
        minBodyHeight={400}
      >
        <GridSection
          showCategory
          title={title}
          maxCharacters={searchTitleMaxCharacters}
          subtitle={filterCountTitle}
          selectedSortOption={selectedSortingOption}
          sortOptions={sortOptions}
          onSortingChanged={onSortingChanged}
          analytics={{
            engagementData: {
              title: 'Search Page',
            },
          }}
        />
      </InfiniteScroll>
      {noResults}
    </div>
  );
};

export default SearchResults;
